import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import {
  ProjectTemplateData,
  useGetAllProjectPhases,
} from 'data/templates/projects';
import {
  findLargestSumOfStartDayDuration,
  findLowestStartDay,
} from 'data/templates/projects/utils';

export const useGanttRef = (showLoader: boolean) => {
  const [ganttRef, setGanttRef] = useState<any>(null);
  const projectPhases = useGetAllProjectPhases();

  const collapseAll = useCallback(
    () => ganttRef?.ganttInstance.collapseAll(),
    [ganttRef],
  );
  const expandAll = useCallback(
    () => ganttRef?.ganttInstance.expandAll(),
    [ganttRef],
  );

  useEffect(() => {
    const lowestStartDay = findLowestStartDay(
      Object.values(projectPhases) as unknown as ProjectTemplateData[],
    );
    const largestDuration = findLargestSumOfStartDayDuration(
      Object.values(projectPhases) as unknown as ProjectTemplateData[],
    );

    const totalDuration = largestDuration - lowestStartDay;

    if (
      ganttRef != null &&
      ganttRef.ganttInstance &&
      !showLoader &&
      !Number.isNaN(totalDuration)
    ) {
      ganttRef.ganttInstance.setTimeSpan(
        moment()
          .add(lowestStartDay, 'days')
          .startOf('day')
          .subtract(1, 'days')
          .toDate(),
        moment()
          .add(lowestStartDay + totalDuration, 'days')
          .add(30, 'days')
          .endOf('day')
          .toDate(),
      );
    }
  }, [ganttRef, projectPhases, showLoader]);

  return {
    ganttRef,
    setGanttRef,
    collapseAll,
    expandAll,
  };
};
